import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SuperAdmin {
  id: string;
  email: string;
  name: string;
  // Set only for dual-mode accounts — presence means "Switch to Admin" can
  // be offered in the portal.
  houseMerchantId?: string | null;
}

interface SuperAdminState {
  admin: SuperAdmin | null;
  token: string | null;
  setAuth: (admin: SuperAdmin, token: string) => void;
  clearAuth: () => void;
  isAuthenticated: () => boolean;
}

export const useSuperAdminStore = create<SuperAdminState>()(
  persist(
    (set, get) => ({
      admin: null,
      token: null,
      setAuth: (admin, token) => {
        localStorage.setItem('sa-token', token);
        set({ admin, token });
      },
      clearAuth: () => {
        localStorage.removeItem('sa-token');
        set({ admin: null, token: null });
      },
      isAuthenticated: () => !!get().token && !!get().admin,
    }),
    {
      name: 'sa-auth',
      partialize: (s) => ({ admin: s.admin, token: s.token }),
    }
  )
);
